function load(path) {
  return () => import(`@/views/${path}`);
}

const routes = [
  {
    path: '/',
    name: 'downloadPage',
    component: load('download/page'),
    meta: { title: '知心天气' },
  },
  {
    path: '/jishi/download',
    name: 'jishiDownload',
    component: load('jishiWeather/page'),
    meta: { title: '及时天气' },
  },
  {
    path: '/ji/download',
    name: 'FloorPage',
    component: load('jiWeather/floorPage'),
    meta: { title: '吉天气' },
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: load('privacy/agreement'),
  },
  {
    path: '/agreement/privacy',
    name: 'PrivacyAgreement',
    component: load('privacy/index'),
  }
]

export default routes;


// WEBPACK FOOTER //
// ./src/router/routes.js